import { c as _c } from "react/compiler-runtime";
import { useFormContext } from 'react-hook-form';
export const RadioCard = t0 => {
  const $ = _c(21);
  const {
    title,
    name,
    value,
    hoverTitle,
    disabled,
    children
  } = t0;
  const {
    register
  } = useFormContext();
  let t1;
  if ($[0] !== title) {
    t1 = <h2 className="card-title">{title}</h2>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children) {
    t2 = children && <p>{children}</p>;
    $[2] = children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="card-body">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const content = t3;
  let t4;
  if ($[7] !== content || $[8] !== disabled || $[9] !== hoverTitle) {
    t4 = disabled && <span className="card card-sm bg-base-100 text-base-content dark:bg-base-200 cursor-not-allowed opacity-50 shadow-lg" role="button" aria-disabled={true} title={hoverTitle}>{content}</span>;
    $[7] = content;
    $[8] = disabled;
    $[9] = hoverTitle;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== content || $[12] !== disabled || $[13] !== hoverTitle || $[14] !== name || $[15] !== register || $[16] !== value) {
    t5 = !disabled && <label className="card card-sm bg-base-100 dark:bg-base-200 text-base-content hover:bg-base-200 dark:hover:bg-base-300 shadow-lg transition hover:shadow-xl" title={hoverTitle}>{content}<input type="radio" {...register(name)} value={value} className="hidden" /></label>;
    $[11] = content;
    $[12] = disabled;
    $[13] = hoverTitle;
    $[14] = name;
    $[15] = register;
    $[16] = value;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== t4 || $[19] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
};